// Components
import { Grid, CardContent, Typography } from "@mui/material";
import { useTheme } from "@mui/styles";
import { Theme } from "@mui/material";
import { IAirport } from "@vmosolutions/oc-interfaces";
import { unset } from "lodash";

interface IAirportInfoProps {
  id: string;
  path: string[];
  airportInfo: IAirport;
}
const airportinfoWindowStyles = (theme: Theme): any => ({
  root: {
    padding: "0px 15px 24px 15px",
    backgroundColor: theme.custom.timeline.contextListBackground,
    width: "100%",

    "& .window_title": {
      display: "flex",
      flexWrap: "wrap",
      alignItems: "center",
      "& .page_header": {
        margin: "5px 0px",
        "& .subheader": {
          margin: "0px 10px",
          color: theme.custom.forms.labels,
        },
      },
    },

    "& .info_message": {
      color: theme.palette.primary.contrastText,
    },

    "& .info_container": {
      minWidth: "290px",
      paddingBottom: "10px",
      border: "1px solid " + theme.custom.forms.inputBorder,
      backgroundColor: theme.custom.forms.inputBack,
      "& .airport_fields": {
        padding: "10px 10px 0px 10px",
        "& .field": {
          margin: 0,
          "& .label": {
            width: "90px",
            textAlign: "right",
            fontSize: 12,
            color: theme.custom.forms.labels,
            margin: "0px 5px",
          },
          "& .value": { fontSize: 12, color: theme.palette.primary.contrastText },
        },
      },
      "& .react_rte_editor": {
        backgroundColor: unset,
        color: theme.palette.common.white,
      },
      "& .label_note": { width: 90, fontSize: 14, color: theme.custom.forms.labels, margin: "0px 5px" },
      "& .airport_note": {
        width: "100%",
        margin: "0px 0px 10px 0px",

        "& .input-base": {
          border: "unset",
          "& .react_rte_editor": { margin: "5px" },
        },
      },
    },

    "& .airport_info": {
      padding: 5,
      minWidth: 210,
      marginRight: 10,
    },
  },
});
export const AirportInfo = (props: IAirportInfoProps): JSX.Element => {
  const { airportInfo } = props;
  const { Ident, IATACode, timezoneId, Loc, Name, CountryCode, ElevationFeet, FIR, note } = airportInfo ?? {};

  return (
    <CardContent sx={(theme) => airportinfoWindowStyles(theme).root}>
      {airportInfo ? (
        <Grid container direction="column" className="info_container">
          <Grid container direction="column" className="airport_fields">
            <Grid container wrap="nowrap" className="field">
              <Grid item className="label">
                Name:
              </Grid>
              <Grid item className="value">
                {Name ?? "_"}
              </Grid>
            </Grid>

            <Grid container wrap="nowrap" className="field">
              <Grid item className="label">
                ICAO / IATA:
              </Grid>
              <Grid item className="value">
                {`${Ident ?? "_"} / ${IATACode ?? "_"}`}
              </Grid>
            </Grid>

            <Grid container wrap="nowrap" className="field">
              <Grid item className="label">
                Lat / Long:
              </Grid>
              <Grid item className="value">
                {`${Loc?.coordinates[1] ?? "_"} / ${Loc?.coordinates[0] ?? "_"}`}
              </Grid>
            </Grid>

            <Grid container wrap="nowrap" className="field">
              <Grid item className="label">
                Country / TZ:
              </Grid>
              <Grid item className="value">
                {`${CountryCode ?? "_"} / ${timezoneId ?? "_"}`}
              </Grid>
            </Grid>

            <Grid container wrap="nowrap" className="field">
              <Grid item className="label">
                Elevation / FIR:
              </Grid>
              <Grid item className="value">
                {`${ElevationFeet ? `${ElevationFeet}ft` : "_"} / ${FIR ?? "_"} `}
              </Grid>
            </Grid>
          </Grid>

          <Grid container direction="column" className="airport_fields" style={{ padding: "0px 10px" }}>
            {/* <Grid item className="label_note">
              Note:
            </Grid> */}
            {airportInfo?.note && <div dangerouslySetInnerHTML={{ __html: airportInfo?.note }} />}
          </Grid>
        </Grid>
      ) : (
        <Grid container direction="column" className="info_message">
          <Typography variant="body2">
            To view airport information, select or search for the airport name, icao or iata in the menu above.
          </Typography>
        </Grid>
      )}
    </CardContent>
  );
};
